module.exports = __webpack_public_path__ + "img/reciclaje-de-aceite2.53431f94.png";